<template>
	<div>
		<p class="mb-2">
			{{ __("Your profile status") }}: {{ __(profileStatus.status) }}
		</p>

		<div v-if="profileStatus.show_progress_bar" class="flex">
			<div
				class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 flex-1 mr-3"
			>
				<div
					:style="percentCompleted"
					class="bg-orange-600 h-2.5 rounded-full"
				></div>
			</div>
			<div class="flex-none">
				{{ profileStatus.score }}/{{ profileStatus.max_score }}
			</div>
		</div>

		<div v-if="profileStatus.score === 6 && profileStatus.show_progress_bar">
			<p class="mb-4">
				{{ __("Congratulations! You have reached the profile status") }}
				<a
					href="#"
					class="text-orange-500 underline italic"
					@click="showProfileStatusModal = true"
					>{{ __(profileStatus.status) }}</a
				>
				<span v-if="locale == 'de'">erreicht</span>
			</p>
		</div>
		<div v-else-if="profileStatus.show_progress_bar">
			<p class="mb-4" v-if="locale == 'de'">
				Noch
				{{ profileStatus.max_score_level - profileStatus.score }} Schritt<span
					v-if="profileStatus.max_score_level - profileStatus.score !== 1"
					>e</span
				>
				bis zum Profilstatus
				<a
					href="#"
					class="text-orange-500 underline italic"
					@click="showProfileStatusModal = true"
					>{{ __(profileStatus.next_status) }}</a
				>
			</p>
			<p class="mb-4" v-else>
				Just
				{{ profileStatus.max_score_level - profileStatus.score }} step<span
					v-if="profileStatus.max_score_level - profileStatus.score !== 1"
					>s</span
				>
				until the profile status
				<a
					href="#"
					class="text-orange-500 underline italic"
					@click="showProfileStatusModal = true"
					>{{ __(profileStatus.next_status) }}</a
				>
			</p>
		</div>

		<div v-if="profileStatus.score === 1">
			<div class="flex mb-5">
				<div class="flex-none">
					<ui-icon
						class="mt-1 mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white md:text-gray-600"
						name="database"
						stroke-width="2"
					/>
				</div>
				<div class="flex-1">
					<p class="mb-3 font-bold">{{ __("Select favorites now") }}</p>
					<p class="mb-3" v-if="locale == 'de'">
						Mit Ausfüllen Ihrer Favoriten im Benutzerprofil unter ‚Meine
						Produkte‘, erhalten Sie auf sich zugeschnittene Informationen.
					</p>
					<p class="mb-3" v-else>
						When filling in your favorities in the user profile under "my
						products", you will receive targeted information.
					</p>
					<ui-button
						type="button"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						v-on:click="
							$bus.$emit(
								'toggle-iframe-modal',
								$route('user.index', { iframe_modal: 1 })
							)
						"
						label="User profile"
					/>
				</div>
			</div>
		</div>
		<div v-else-if="profileStatus.score === 2">
			<div class="flex mb-5">
				<div class="flex-none">
					<ui-icon
						class="mt-1 mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white md:text-gray-600"
						name="edit"
						stroke-width="2"
					/>
				</div>
				<div class="flex-1">
					<p class="mb-3 font-bold">
						{{ __("Create an offer and increase your visibility") }}
					</p>
					<p class="mb-3">
						{{
							__(
								"Users with an active offer receive personalised price quotes from interested buyers"
							)
						}}
					</p>
					<ui-button
						type="button"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						v-on:click="
							$bus.$emit('toggle-iframe-modal', $route('offers.create'))
						"
						label="New offer"
					/>
				</div>
			</div>
		</div>
		<div v-else-if="profileStatus.score === 3">
			<div class="flex mb-5">
				<div class="flex-none">
					<ui-icon
						class="mt-1 mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white md:text-gray-600"
						name="search"
						stroke-width="2"
					/>
				</div>
				<div class="flex-1">
					<p class="mb-3 font-bold">
						{{ __("Offer your products and receive the best price") }}
					</p>
					<p class="mb-3">
						{{
							__(
								"Users who negotiatiate their prices can earn up to 10 €/t more"
							)
						}}
					</p>
					<page-link
						acl="can_trade"
						:href="$route('search.index')"
						type="button"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						>{{ __("Search") }}</page-link
					>
				</div>
			</div>
		</div>
		<div v-else-if="profileStatus.score === 4">
			<div class="flex mb-5">
				<div class="flex-none">
					<ui-icon
						class="mt-1 mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white md:text-gray-600"
						name="message-square"
						stroke-width="2"
					/>
				</div>
				<div class="flex-1">
					<p class="mb-3 font-bold">
						{{ __("Conclude a contract and enjoy your marketing success") }}
					</p>
					<p class="mb-3">
						{{
							__(
								'Users with at least one contract can track their distribution through the "My Contracts" tab'
							)
						}}
					</p>
					<page-link
						acl="can_trade"
						:href="$route('threads')"
						type="button"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						>{{ __("Negotiation & Settlement") }}</page-link
					>
				</div>
			</div>
		</div>
		<div v-else-if="profileStatus.score === 5">
			<div class="flex mb-5">
				<div class="flex-none">
					<ui-icon
						class="mt-1 mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white md:text-gray-600"
						name="briefcase"
						stroke-width="2"
					/>
				</div>
				<div class="flex-1">
					<p class="mb-3 font-bold">Vermarktungsdashboard erkunden</p>
					<p class="mb-3">
						Mit dem Dashboard können Sie vergleichen und analysieren und Sie
						behalten Ihre Vermarktung dauerhaft im Blick.
					</p>
					<page-link
						acl="can_trade"
						:href="$route('my_contracts.index')"
						type="button"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						>{{ __("Dashboard") }}</page-link
					>
				</div>
			</div>
		</div>
		<div v-else-if="profileStatus.score === 6">
			<div class="flex mb-5">
				<div class="flex-none">
					<ui-icon
						class="mt-1 mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white md:text-gray-600"
						name="users"
						stroke-width="2"
					/>
				</div>
				<div class="flex-1">
					<p class="mb-3 font-bold">{{ __("Refer your friends") }}</p>
					<p class="mb-3">
						{{ __("Show your friends how to be successful on cropspot!") }}
					</p>
					<ui-button
						type="button"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						v-on:click="
							$bus.$emit(
								'toggle-iframe-modal',
								$route('user.index', { iframe_modal: 1 })
							)
						"
						label="User profile"
					/>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="flex mb-5">
				<div class="flex-none">
					<ui-icon
						class="mt-1 mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white md:text-gray-600"
						name="user"
						stroke-width="2"
					/>
				</div>
				<div class="flex-1">
					<p class="mb-3 font-bold">
						{{ __("Complete your profile and discover cropspot") }}
					</p>
					<p class="mb-3">
						{{
							__(
								"Only afer completing your profile can we activate your account and enable the full cropspot functionality"
							)
						}}
					</p>
					<ui-button
						type="button"
						class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 border border-transparent shadow-sm hover:bg-orange-600 focus:outline-none font-medium"
						v-on:click="
							$bus.$emit(
								'toggle-iframe-modal',
								$route('user.index', { iframe_modal: 1 })
							)
						"
						label="User profile"
					/>
				</div>
			</div>
		</div>

		<hr class="my-4" />

		<user-profile-status-modal
			v-if="showProfileStatusModal"
			v-on:close="showProfileStatusModal = false"
		></user-profile-status-modal>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		profileStatus: {
			type: Object,
		},
	},
	computed: {
		percentCompleted() {
			return "width: " + this.profileStatus.percent_finished + "%";
		},
	},
	data() {
		return {
			showProfileStatusModal: false,
		};
	},
};
</script>
